module.exports = __webpack_public_path__ + "img/wf-index-example.af909458.svg";